import { useCallback, useEffect, useMemo, useState } from "react"
import { useDirect } from "../pages/direct/match/DirectContext.js"
import { useDispatch } from "react-redux"
import { updateMatch } from "../../actions/matchs.js"
import { getAllMatchPeriods, getMinTotalDuration, getPeriod, getPlayedGamesPeriods, } from "../sports/rules.js"
import { getPeriodEvents } from "../pages/direct/match/data/gameEvents.js"
import StyledPeriodButton from "../pages/direct/match/components/buttons/StyledPeriodButton.js"

export const useMatchTimer = () => {

    const dispatch = useDispatch()
    const match = useDirect()

    const timeOffset = useMemo(() => {
    // On s’aligne sur la même logique que pour les stats / temps de jeu
    //ici il faut récupérer les periodes jouables et ensuite récupérer le minDuration de la periode actuelle
    let currentPeriod = getPeriodPlayedModel(match.discipline, match.period);
    if (!currentPeriod){
        currentPeriod = getPeriodModel(match.discipline, match.period);
        //TODO OPTA PER 2 - bout de scotch là
                if (!currentPeriod){
                    currentPeriod = getPeriodModel(match.discipline, 6);
                }
    }
    const baseMinutes = currentPeriod?.minDuration || 0;

    // const baseMinutes = getMinTotalDuration(match.period, match.discipline);
    return baseMinutes * 60;
    }, [match.period, match.discipline]);

    const [timer, setTimer] = useState(match.timer); // Temps en secondes
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {

        if(match.statusTimer === 'off'){
            setIsRunning(false)
        }else if(match.statusTimer === 'on'){
            setIsRunning(true)
        }

    }, [,match.statusTimer])

    useEffect(() => {
        //if(match.statusTimer === 'off')
            setTimer(match.timer)
    }, [match.timer])

    useEffect(() => {

        let interval = null;
        if (isRunning) {
          interval = setInterval(() => {
            setTimer((prevTime) => prevTime + 1);
          }, 1000);
        } else {
          clearInterval(interval);
        }
        return () => clearInterval(interval);
      }, [isRunning]);

    function changeStatusTimer(){

        // // On bloque le chrono si :
        // // - la période courante est "tirs au but" (periodPhase === 'so')
        // const currentPeriodModel = getPeriod(match.period, match.discipline);
        // const isShootoutPhase = currentPeriodModel?.periodPhase === 'so';

        // if (isShootoutPhase) {
        //     // On ne touche pas au timer ni au statusTimer
        //     return;
        // }

        dispatch(updateMatch(match._id, {
            timer,
            statusTimer : !isRunning ? 'on' : 'off', 
            lastUpdateStatus : new Date()
        }))
    }

    function isTimerLocked() {
        const currentPeriodModel = getPeriodPlayedModel(match.discipline, match.period);
        const isShootoutPhase = currentPeriodModel?.periodPhase === 'so';
        return match.status === 'end' || isShootoutPhase;
    }

    //TODO utiliser celui de rules.js
    function getPeriodPlayedModel(discipline, matchPeriod) {
        const allPeriods = getPlayedGamesPeriods(discipline);
        const periodModel = [...allPeriods.values()]
            .find(p => p.matchPeriod === matchPeriod);

        return periodModel;
        }
//TODO utiliser celui de rules.js
    function getPeriodModel(discipline, matchPeriod) {
        const allPeriods = getAllMatchPeriods(discipline);
        const periodModel = [...allPeriods.values()]
            .find(p => p.matchPeriod === matchPeriod);

        return periodModel;
        }

    function startPeriod(period) {
        let statusTimer;
        let newTimer;

        if (match.discipline === 'basket') {
            // Basket : logique historique inchangée
            statusTimer = 'off';
            newTimer = 1;
        } else {
            // Rugby, foot, etc. : on garde le timer courant (delta déjà calculé)
            statusTimer = isTimerLocked() ? 'off' : 'on';
            newTimer = Number.isFinite(match.timer) && match.timer >= 1 ? match.timer : 0;
        }

        dispatch(updateMatch(match._id, {
            statusTimer,
            period,
            timer: newTimer,
            lastUpdateStatus: new Date(),
        }));
        }

    function stopPeriod(nextPeriod, status = 'normal', stopMinute = null) {
        const discipline = match.discipline;
        const currentPeriodNumber = match.period;
        const currentPeriod = getPeriodPlayedModel(discipline, currentPeriodNumber);

        let nextPeriodModel = getPeriodPlayedModel(discipline, nextPeriod);
            if (!nextPeriodModel){
                nextPeriodModel = getPeriodModel(discipline, nextPeriod);
            }
        
        let currentPeriodModel = getPeriodPlayedModel(discipline, currentPeriodNumber);
        if (!currentPeriodModel){
            currentPeriodModel = getPeriodModel(discipline, currentPeriodNumber)
            //TODO OPTA PER 2 - bout de scotch là
                if (!currentPeriodModel){
                    currentPeriodModel = getPeriodModel(discipline, 6);
                }
            }

        const baseMinutesNext = nextPeriodModel?.minDuration || 0;
        const baseMinutesCurrent = currentPeriodModel?.minDuration || currentPeriodModel?.maxDuration;
        const maxMinutesNext = nextPeriodModel?.maxDuration || currentPeriod.maxDuration;
        const maxMinutesCurrent = currentPeriodModel?.maxDuration || 0;

        let newTimerSeconds = 0;

        if (typeof stopMinute === 'number' && !Number.isNaN(stopMinute)) {

             console.log('Stop period from shootout to end, keeping stopMinute:', stopMinute);
                console.log('Details:', {
                    stopMinute,
                    baseMinutesCurrent,
                    baseMinutesNext,
                });

                let timerCalc = maxMinutesCurrent;

                
                //ne jamais dépasser le maxDuration d'un tir au but (avec prolongations) // au timer saisi
             if (baseMinutesNext < timerCalc) {
           
                // const maxDurationAllowed = nextPeriodModel.maxDuration || currentPeriod.maxDuration;
                if (maxMinutesNext > timerCalc) {
                    newTimerSeconds = Math.round((timerCalc - baseMinutesNext) * 60);
                } else {
                    newTimerSeconds = Math.round((maxMinutesNext - baseMinutesNext) * 60);
                }
            }else{
                newTimerSeconds = 0;
            }
        }

        setTimer(newTimerSeconds);

        dispatch(updateMatch(match._id, {
            statusTimer: 'off',
            period: nextPeriod,
            timer: newTimerSeconds,
            status,
            lastUpdateStatus: new Date()
        }));
    }

    // Détermine "où on en est" pour calculer le texte du bouton de période
    const resolveCurrentPeriodIndex = (match) => {
        const allPeriods = getAllMatchPeriods(match.discipline);
        const entries = Array.from(allPeriods.entries()).sort(
            ([a], [b]) => a - b
        );

        //CAS OPTA fin de match
        //TODO OPTA PER 2 - bout de scotch là
        const optaCase = match.discipline!=='handball' && match.discipline!=='basket' && match.period === 2
            if (optaCase){
                const endMatchOpta = entries.filter(
                ([, p]) =>
                p.matchPeriod === 6
            );

             if (endMatchOpta) {
                return endMatchOpta[0][0] || 10;
            }
        }
        
        // Cas 0 : match vraiment non démarré
        if (
            match.period === 0 &&
            match.timer === 0 &&
            match.statusTimer === "off"
        ) {
            return 0; // NON_DEMARRE
        }

        // Helper : tous les PeriodModel jouables pour ce match.period
        const playableCandidates = entries.filter(
            ([, p]) => p.isPlayable && p.matchPeriod === match.period
        );

        const pickMaxMinDurationKey = (candidates) => {
            const [bestKey] = candidates.reduce(
            (best, current) => {
                const [, bestP] = best;
                const [, curP] = current;
                return curP.minDuration > bestP.minDuration ? current : best;
            },
            candidates[0]
            );
            return bestKey;
        };

        // 1) Chrono en cours → on est forcément "dans" une période jouable
        if (match.statusTimer === "on" && playableCandidates.length > 0) {
            return pickMaxMinDurationKey(playableCandidates);
        }

        // 2) Chrono en pause mais du temps a déjà été joué → on reste dans la période jouable
        if (match.timer > 0 && playableCandidates.length > 0) {
            return pickMaxMinDurationKey(playableCandidates);
        }

        // EXCEPTION 'so' tirs au buts, il faut la periode jouable actuelle, sans regarder le match.timer
        if (match.timer >= 0 && playableCandidates.length > 0) {
            const shootoutCandidate = playableCandidates.find(
                ([, p]) => p.periodPhase === "so"
            );
            if (shootoutCandidate) {
                return shootoutCandidate[0];
            }
        }

        // 3) Sinon : on est entre deux périodes
        //  → on prend la fin de période correspondante
        const endCandidates = entries.filter(
            ([, p]) =>
            !p.isPlayable &&
            p.matchPeriod === match.period &&
            p.periodPhase !== "start" // on exclut "Non démarré"
        );

        if (endCandidates.length > 0) {
            return pickMaxMinDurationKey(endCandidates);
        }

        // 4) Filet de sécurité : si on trouve malgré tout une période jouable, on l'utilise
        if (playableCandidates.length > 0) {
            return pickMaxMinDurationKey(playableCandidates);
        }

        // 5) Fallback ultime
        return 0;
    };

    const getPeriodAction = useCallback((handleEventClick) => {
        const allPeriods = getAllMatchPeriods(match.discipline);
        const periodsArray = [...allPeriods.entries()].sort(([a], [b]) => a - b);

        const currentIndex = resolveCurrentPeriodIndex(match);
        let currentPeriod = allPeriods.get(currentIndex);
        const nextEntry = allPeriods.get(currentIndex + 1) ? [currentIndex + 1, allPeriods.get(currentIndex + 1)] : null;
        const nextPeriod = nextEntry ? nextEntry[1] : null;

        //TODO OPTA PER 2 - bout de scotch là
        const optaCase = match.discipline!=='handball' && match.discipline!=='basket' && match.period === 2
            if (optaCase){
                currentPeriod = [...allPeriods.values()]
                .find(p => p.matchPeriod === 6);
        }

        // Période "match terminé"
        const endPeriod = periodsArray.find(([, p]) => p.periodPhase === 'end');
        const isMatchEnded =
            match.status === 'end' ||
            (endPeriod && match.period === endPeriod[1].matchPeriod) ||
            (currentPeriod && currentPeriod.periodPhase === 'end');



        if (!currentPeriod) {
            // Sécurité : on ne fait rien si on ne sait pas où on est
            return (
                <StyledPeriodButton
                    onClick={() => {}}
                    disabled
                    text="Période inconnue"
                />
            );
        }

        if (isMatchEnded || !nextPeriod) {
            // Plus rien à jouer → bouton désactivé avec le libellé de la période
            const label = endPeriod ? endPeriod[1].name : currentPeriod.name;
            return (
                <StyledPeriodButton
                    onClick={() => {}}
                    disabled
                    text={label}
                />
            );
        }

        const periodEvent = getPeriodEvents(match.discipline);

        console.log('check ici')

        // --- Cas 1 : prochaine période jouable → bouton "Début ..."
        if (nextPeriod.isPlayable) {
            const textButton = `Début ${nextPeriod.name}`;

            const onClickParam = () => {
                handleEventClick(
                    { ...periodEvent[0], isEnableTrigger: currentIndex === 0 },
                    () => {
                        // On démarre toujours la période jouable suivante
                        startPeriod(nextPeriod.matchPeriod);
                    }
                );
            };

            return (
                <StyledPeriodButton
                    onClick={onClickParam}
                    disabled={false}
                    text={textButton}
                />
            );
        }

        // --- Cas 2 : prochaine période non jouable → "Fin <période courante>"
        const textButton =
            currentPeriod.name === 'Match terminé'
                ? currentPeriod.name
                : `Fin ${currentPeriod.name}`;

        const onClickParam = () => {
            handleEventClick(periodEvent[1], (event) => {
                const entries = Array.from(allPeriods.entries());

                console.log('Stop period clicked for event:', event);

                const deltaMinutes = Number(event.timer) || 0;
                const baseCurrent = getMinTotalDuration(event.period, match.discipline);
                const stopMinuteGlobal = baseCurrent + deltaMinutes;

                if (event.detail.reason === 'end') {
                    // On force la vraie période "match terminé"
                    const lastPeriodIndex = entries.length - 1;
                    const lastPeriod = entries[lastPeriodIndex][1];
                    //TODO refacto surement comme ça ici aussi :
                    // const endPeriod = [...allPeriods.values()].find(p => p.periodPhase === 'end');
                    //idem plus bas dans next
                    stopPeriod(lastPeriod.matchPeriod, 'end', stopMinuteGlobal);
                } else if (event.detail.reason === 'tab') {
                    console.log('ici tirs au but');
                    // const tabPeriod = entries.find(([, p]) => p.periodPhase === 'so');
                    const tabPeriod = [...allPeriods.values()].find(p => p.periodPhase === 'so');
                    // const preLastPeriodIndex = entries.length - 2;
                    // const preLastPeriod = entries[preLastPeriodIndex][1];
                    stopPeriod(tabPeriod.matchPeriod, 'normal', stopMinuteGlobal);
                } else if (event.detail.reason === 'next') {
                    // Passage à l'étape suivante dans la timeline (ex : fin MT1 → MT2)
                    stopPeriod(nextPeriod.matchPeriod, 'normal', stopMinuteGlobal);
                }
            });
        };

        return (
            <StyledPeriodButton
                onClick={onClickParam}
                disabled={false}
                text={textButton}
            />
        );
    }, [match]);

    function updateMatchChrono(payload){
        const {period} = payload

        let status
        // Si period vaut la derniere des periodes, alors status = 'end', sinon status = 'normal'
        const allPeriods = getAllMatchPeriods(match.discipline)
        const periodEntries = [...allPeriods.entries()]
        const lastPeriod = periodEntries[periodEntries.length - 1];

        if(lastPeriod && lastPeriod[1].matchPeriod === period)
            status = 'end'
        else
            status = 'normal'

        dispatch(updateMatch(match._id, {...payload, status}))
    }


function getCurrentMatchPeriodName() {
    // console.log('get period name')
    const allPeriods = getAllMatchPeriods(match.discipline);
    const index = resolveCurrentPeriodIndex(match);
    const periodModel = allPeriods.get(index);
    return periodModel?.name ?? '';
}

return {
    changeStatusTimer,
    getPeriodAction,
    updateMatchChrono,
    timer,
    //CAS OPTA fin de match
    //TODO OPTA PER 2 - bout de scotch là
    period: (match.discipline!=='handball' && match.discipline!=='basket' && match.period === 2) ? 6 : match.period,
    isRunning,
    timeOffset,
    getCurrentMatchPeriodName,
    isTimerLocked: isTimerLocked(),
};

    // return { changeStatusTimer, getPeriodAction, updateMatchChrono, timer, period : match.period, isRunning, timeOffset, getCurrentMatchPeriodName }

}